export default {
  title: '登录画面',
  email: '邮箱地址',
  emailPlaceholder: '请输入',
  password: '密码',
  passwordPlaceholder: '请输入',
  rememberMe: '记住登录信息',
  forgotPassword: '忘记密码',
  loginButton: '登录',
  agreement: '我已阅读并同意#serviceAgreement#和#privacyAgreement#',
  serviceAgreement: '服务协议',
  privacyAgreement: '隐私协议',
  and: '和',
  emailRequired: '请输入邮箱地址',
  passwordRequired: '请输入密码',
  emailInvalid: '邮箱格式不正确',
  passwordInvalid: '密码至少需要8个字符，包含字母和数字',
  agreementRequired: '请同意服务协议和隐私协议',
  loading: '登录中...',
  loginSuccess: '登录成功',
  loginFailed: '登录失败'
};
